module.exports = __webpack_public_path__ + "static/images/chart-bars.adf0b161bbd526108436f6741d19b244.svg";